var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"my-study-page"},[_c('MyLayout',{attrs:{"menuList":_vm.myStudyMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }